import { useAuth } from '@clerk/clerk-react';
import { getOrganization } from '@/state/queries/organizations/use-get-organization';
import { useMutation } from '@tanstack/react-query';

export const useGetOrganizationMutation = () => {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (id: string) => {
      const token = await getToken();
      return getOrganization(id, token ?? '');
    },
  });
};
